function Timestmap() {
    return (<div>
        {Date.now()}
    </div>);
}


export default Timestmap;